import type { TableSkeletonProps } from "./types-skeleton";
import { useTableSkeleton } from "./use-skeleton";
import { TableSkeletonView } from "./view-table-skeleton";

export function TableSkeleton(props: TableSkeletonProps) {
  const viewModel = useTableSkeleton(props);

  return <TableSkeletonView {...viewModel} />;
}
TableSkeleton.displayName = "TableSkeleton";
